import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import {yieldlockRegister} from "../../services/yieldlockRegister";

class YieldlockCalculator extends Component {

    constructor(props) {
        super(props);
        this.state = {
            years: 0,
            list_price: 0,
            upfront_to_seller: 0,
            market_price: 0,
            yield: 5,
            up_front: false
        };
    };

    componentWillMount() {
        window.scrollTo(0, 0);
    };

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            ltvWarning: nextProps.ltvWarning,
            inhouse: nextProps.inhouse
        })
    }

    componentDidMount() {

        if (yieldlockRegister.getValue('yield')) {
            this.state.yield = yieldlockRegister.getValue('yield');
        }else{
            yieldlockRegister.setValue('yield', this.state.yield);
        }

        if (yieldlockRegister.getValue('list_price')) {
            this.state.list_price = yieldlockRegister.getValue('list_price');
        }else{
            this.state.list_price = this.props.list_price;
        }

        this.setState({
            market_price: this.props.market_price,
            market_rent: this.props.market_rent,
            list_price: this.state.list_price,
            years: this.props.years,
            yield: this.state.yield,
            up_front: this.props.up_front,
            inhouse: this.props.inhouse
        }, () => {
            this.props.updateListPrice(this.state.list_price);
            this.props.updateYield(this.state.yield);
        });

    }

    scraper = {};

    init = {};

    functions = {};

    renders = {
        text: (item) => {
            return langRegister.get("booster-industry", item);
        },
        number: (number) => {
            try {
                number = Math.round(number);
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            } catch (e) {
                return ("...")
            }
        },
        format: (num, digits) => {
            var si = [
                { value: 1, symbol: "" },
                { value: 1E3, symbol: "k" },
                { value: 1E6, symbol: "M" },
                { value: 1E9, symbol: "G" },
                { value: 1E12, symbol: "T" },
                { value: 1E15, symbol: "P" },
                { value: 1E18, symbol: "E" }
            ];
            var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
            var i;
            for (i = si.length - 1; i > 0; i--) {
                if (num >= si[i].value) {
                    break;
                }
            }
            return (num / si[i].value).toFixed(1).replace(rx, "$1") + si[i].symbol;
        },
        years: () => {
            let years = [];
            for(let i = 0; i < this.state.years; i++){
                years.push({percentage: this.state.yield, year: i + 1, value: this.state.yield * (this.state.list_price / 100)});
            }
            if(this.state.up_front){
                let value_total = 0;
                let yield_total = 0;
                years.map((item) => {
                    value_total += +item.value;
                    yield_total += +item.percentage;
                    item.value = 0;
                    item.percentage = 0;
                });
                years[0].value = value_total;
                years[0].percentage = yield_total;
            }
            return years;
        },
        upfront: () => {
            let total_yields = 0;
            this.renders.years().map((item) => {
                total_yields = total_yields + item.value;
            });
            return this.state.list_price - total_yields;
        },
        upfrontHeight: () => {
            return (this.renders.suggestedListPriceFixedPoint()*(this.renders.upfront()/this.state.list_price))+'px';
        },
        marketPriceFixedPoint: () => {
            let default_value = '380px';
            if(this.state.market_price < this.state.list_price){
                default_value = 380*(this.state.market_price/this.state.list_price)+'px';
            }
            return default_value;
        },
        suggestedListPriceFixedPoint: () => {
            let default_value = 380;
            if(this.state.market_price > this.state.list_price){
                let difference = this.state.list_price / this.state.market_price;
                default_value = (380 * difference);
            }
            return default_value;
        }
    };

    render() {
        return (
            <div className={Styles.container}>
                <div className={Styles.topSection}>
                    <div className={Styles.topSectionLeft}>
                        <div className={cx(Styles.topSectionTitle, Styles.topSectionTitlePadding)}>
                            <div className={Styles.topSectionTitleText}>Gross yield to buyer</div>
                            {
                                this.state.inhouse &&
                                <div onClick={() => {
                                    this.setState({
                                        up_front: !this.state.up_front
                                    }, () => {
                                        yieldlockRegister.setValue('up_front', this.state.up_front);
                                        this.props.updateUpfront(this.state.up_front);
                                    })
                                }} style={this.state.up_front?{color: '#00273A'}:{}} className={Styles.topSectionBoxLeftSliderTitle}>up-front</div>
                            }
                            {
                                this.state.inhouse &&
                                <div onClick={() => {
                                    this.setState({
                                        up_front: !this.state.up_front
                                    }, () => {
                                        yieldlockRegister.setValue('up_front', this.state.up_front);
                                        this.props.updateUpfront(this.state.up_front);
                                    })
                                }} className={Styles.topSectionBoxLeftSlider}>
                                    {
                                        !this.state.up_front &&
                                        <img className={Styles.topSectionBoxLeftSliderItem} src={require("../../assets/images/slider_deactive_yl.svg")}/>
                                    }
                                    {
                                        this.state.up_front &&
                                        <img className={Styles.topSectionBoxLeftSliderItem} src={require("../../assets/images/slider_active_yl.svg")}/>
                                    }
                                </div>
                            }
                        </div>
                        <div style={this.state.ltvWarning?{borderColor:"#E65032"}:{}} className={cx(Styles.topSectionBox)}>
                            <div style={this.state.ltvWarning?{borderColor:"#E65032"}:{}} className={Styles.topSectionBoxLeft}>
                                <div className={Styles.topSectionBoxLeftText}>
                                    {this.state.yield}
                                    <span className={Styles.topSectionBoxLeftTextDecimal}>%</span>
                                </div>
                                <div className={Styles.topSectionBoxLeftButtons}>
                                    <div onClick={() => {
                                            if(this.state.yield > 3){
                                                this.setState({
                                                    yield: +this.state.yield - 1
                                                }, () => {
                                                    yieldlockRegister.setValue('yield', +this.state.yield);
                                                    this.props.updateYield(+this.state.yield)
                                                })
                                            }
                                    }} className={
                                        cx(Styles.topSectionBoxLeftButtonsItem,
                                            {
                                                [Styles.topSectionBoxLeftButtonsItemActive]: this.state.auto,
                                            })
                                    }>
                                        <img className={Styles.topSectionBoxLeftButtonsItemMinus} src={require("../../assets/images/minus_icon_white_small.png")}/>
                                    </div>
                                    <div onClick={() => {
                                        if(this.state.yield < 9 ){
                                            this.setState({
                                                yield: +this.state.yield + 1
                                            }, () => {
                                                yieldlockRegister.setValue('yield', +this.state.yield);
                                                this.props.updateYield(+this.state.yield)
                                            })
                                        }
                                    }} className={
                                        cx(Styles.topSectionBoxLeftButtonsItem,
                                            {
                                                [Styles.topSectionBoxLeftButtonsItemActive]: this.state.auto,
                                            })
                                    }>
                                        <img className={Styles.topSectionBoxLeftButtonsItemPlus} src={require("../../assets/images/plus_sign_white_small.png")}/>
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.topSectionBoxRight}>
                                <div className={Styles.topSectionBoxRightText}>
                                     <span className={Styles.topSectionBoxRightTextCurrency}>
                                        AED
                                    </span>
                                    {this.renders.number((this.state.list_price/100)*this.state.yield)}
                                </div>
                            </div>
                        </div>
                        {
                            this.state.ltvWarning &&
                            <div className={Styles.yieldError}>total yield exceeds LTV</div>
                        }
                    </div>
                    <div className={Styles.topSectionRight}>
                        <div className={Styles.topSectionTitle}>
                            <div className={Styles.topSectionTitleText}>Suggested list price</div>
                            {
                                false &&
                                <div style={!this.state.auto?{color: '#00273A'}:{}} className={Styles.topSectionBoxLeftSliderTitle}>manual</div>
                            }
                            {
                                false &&
                                <div onClick={() => {
                                    this.setState({
                                        auto: false
                                    })
                                }} className={Styles.topSectionBoxLeftSlider}>
                                    {
                                        this.state.auto &&
                                        <img className={Styles.topSectionBoxLeftSliderItem} src={require("../../assets/images/slider_deactive_yl.svg")}/>
                                    }
                                    {
                                        !this.state.auto &&
                                        <img className={Styles.topSectionBoxLeftSliderItem} src={require("../../assets/images/slider_active_yl.svg")}/>
                                    }
                                </div>
                            }
                        </div>
                        <div className={cx(Styles.topSectionBox, Styles.topSectionBoxSecond)}>
                            <div className={Styles.topSectionBoxRight}>
                                <div className={Styles.topSectionBoxRightTextDark}>
                                     <span className={Styles.topSectionBoxRightTextCurrency}>
                                        AED
                                    </span>
                                    {this.renders.number(this.state.list_price)}
                                </div>
                                <div className={Styles.topSectionBoxLeftButtons}>
                                    <div onClick={() => {
                                        if((+this.state.market_price / 2) < (+this.state.list_price - 10000)){
                                            this.setState({
                                                list_price: +this.state.list_price - 10000
                                            }, () => {
                                                this.props.updateListPrice(+this.state.list_price)
                                            })
                                        }
                                    }} className={
                                        cx(Styles.topSectionBoxLeftButtonsItem,
                                            {
                                                [Styles.topSectionBoxLeftButtonsItemActive]: !this.state.auto,
                                            })
                                    }>
                                        <img className={Styles.topSectionBoxLeftButtonsItemMinus} src={require("../../assets/images/minus_icon_white_small.png")}/>
                                    </div>
                                    <div onClick={() => {
                                        this.setState({
                                            list_price: +this.state.list_price + 10000
                                        }, () => {
                                            this.props.updateListPrice(+this.state.list_price)
                                        })
                                    }} className={
                                        cx(Styles.topSectionBoxLeftButtonsItem,
                                            {
                                                [Styles.topSectionBoxLeftButtonsItemActive]: !this.state.auto,
                                            })
                                    }>
                                        <img className={Styles.topSectionBoxLeftButtonsItemPlus} src={require("../../assets/images/plus_sign_white_small.png")}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={Styles.bottomSection}>
                    <div style={{bottom: this.renders.marketPriceFixedPoint()}} className={Styles.bottomSectionMarketBenchMark}>
                        <div className={Styles.bottomSectionMarketBenchMarkText}>
                            <div className={Styles.bottomSectionMarketBenchMarkTextInner}>
                                <div>Market</div>
                                <div>price</div>
                            </div>
                        </div>
                    </div>
                    <div className={Styles.bottomSectionBars}>
                        <div style={{height: "380px"}} className={Styles.bottomSectionBarsSuggestedPrice}>
                            <div style={{height: this.renders.suggestedListPriceFixedPoint() + "px"}} className={Styles.bottomSectionBarsSuggestedPriceInner}>
                                <div className={Styles.bottomSectionBarsSuggestedPriceInnerRelative}>
                                    {
                                        this.state.list_price > this.state.market_price &&
                                        <div className={Styles.bottomSectionBarsSuggestedPriceValue}>
                                            {this.renders.format(this.state.list_price, 3)}
                                        </div>
                                    }
                                    {
                                        this.state.list_price <= this.state.market_price &&
                                        <div className={Styles.bottomSectionBarsSuggestedPriceValueBelow}>
                                            {this.renders.format(this.state.list_price, 3)}
                                        </div>
                                    }
                                    <div className={Styles.bottomSectionBarsSuggestedPriceTitle}>
                                        Suggested list price
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            this.renders.years().length > 0 &&
                            <div className={Styles.bottomSectionBarsSuggesteYears}>
                                <div className={Styles.bottomSectionBarsSuggesteYearsTop}></div>
                                <div className={Styles.bottomSectionBarsSuggesteYearsBottom}>
                                    <div className={Styles.bottomSectionBarsSuggesteYearsMobile}>
                                        {this.renders.format(this.renders.years()[0].value, 3)}
                                        <span className={
                                            cx(Styles.bottomSectionBarsSuggesteYearsMobileSpace,{
                                                    [Styles.bottomSectionBarsSuggestedYieldLast]: this.state.up_front,
                                                })
                                        }>
                                            x {this.renders.years().length}
                                        </span>
                                    </div>
                                    {
                                        this.renders.years().map((item, index) => {
                                            return (
                                                <div className={
                                                    cx(Styles.bottomSectionBarsSuggestedYield,
                                                        {
                                                            [Styles.bottomSectionBarsSuggestedYieldLast]: index > 0 && this.state.up_front,
                                                        })
                                                }>
                                                    <div className={Styles.bottomSectionBarsSuggestedYieldTop}></div>
                                                    <div style={{height: (this.renders.suggestedListPriceFixedPoint() / 100)*item.percentage + 'px'}} className={Styles.bottomSectionBarsSuggestedYieldBottom}>
                                                        <div className={Styles.bottomSectionBarsSuggestedYieldBottomValue}>
                                                            {this.renders.format(item.value, 3)}
                                                        </div>
                                                        <div className={Styles.bottomSectionBarsSuggestedYieldBottomYear}>
                                                            <div>Year</div>
                                                            <div>{item.year}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        }
                        <div className={Styles.bottomSectionBarsSuggestedSpace}/>
                        <div className={Styles.bottomSectionBarsSuggestedUpfront}>
                            <div className={Styles.bottomSectionBarsSuggestedUpfrontTop}/>
                            <div style={{height: this.renders.upfrontHeight()}} className={Styles.bottomSectionBarsSuggestedUpfrontBottom}>
                                {
                                    this.renders.upfront() > this.state.market_price &&
                                    <div className={Styles.bottomSectionBarsSuggestedUpfrontBottomValue}>
                                        {this.renders.format(this.renders.upfront(), 3)}
                                    </div>
                                }
                                {
                                    this.renders.upfront() <= this.state.market_price &&
                                    <div className={Styles.bottomSectionBarsSuggestedUpfrontBottomValueBelow}>
                                        {this.renders.format(this.renders.upfront(), 3)}
                                    </div>
                                }
                                <div className={Styles.bottomSectionBarsSuggestedUpfrontBottomTitle}>
                                    Up-front to seller
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={Styles.bottomSectionDivider}/>
                </div>
            </div>
        );
    }
}

export default YieldlockCalculator;


// WEBPACK FOOTER //
// ./src/components/yieldlock-calculator/component.js